// Every stand the mill runs, in [Order]. S1 is the shear and carries HasPass = 0,
// so the detail procedure can never return a row for it.
export const STAND_COLUMNS = [
	"H1",
	"V2",
	"H3",
	"HV4",
	"V5",
	"H6",
	"H7",
	"V8",
	"H9",
	"H10",
	"HV11",
	"H12",
	"H13",
	"HV14",
	"H15",
	"HV16",
	"H17",
] as const;

export type StandColumnName = (typeof STAND_COLUMNS)[number];

export interface ProductsHistoryRow {
	CampaignId: number;
	FirstBilletStart: string | null;
	LastBilletEnd: string | null;
	ProductName: string;
	ProductTypeId: number | null;
	ProductTypeName: string | null;
	ProductSizeId: number | null;
	ProductSizeName: string | null;
	RecipeId: number | null;
	RecipeName: string | null;
	CorrectPassCount: number;
	CorrectPassRolledTonnage: number;
	WrongPassCount: number;
	WrongPassRolledTonnage: number;
}

export interface CampaignBilletStand {
	PassNameConfigured: string | null;
	PassNameSetup: string | null;
	WrongPass: boolean;
}

// The stand columns are spread onto the row itself so AG Grid can bind them as
// plain fields.
export type CampaignBilletRow = {
	BilletId: number;
	Start: string | null;
	End: string | null;
} & Partial<Record<StandColumnName, CampaignBilletStand>>;

export interface ProductsHistoryPickerCrew {
	Id: string;
}

export interface ProductsHistoryPickerProductSize {
	Id: number;
	Name: string;
	ProductTypeId: number;
}

export interface ProductsHistoryPickerProductType {
	Id: number;
	Name: string;
}

export interface ProductsHistoryPickers {
	crews: ProductsHistoryPickerCrew[];
	productSizes: ProductsHistoryPickerProductSize[];
	productTypes: ProductsHistoryPickerProductType[];
}
